exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".Background--background--3QmVr{fill:var(--bkgrnd)}.Background--background--3QmVr,.Background--threeHrLine--3tNeU{stroke:var(--bkgrnd-lines);stroke-width:1px}", ""]);

// exports
exports.locals = {
	"background": "Background--background--3QmVr",
	"threeHrLine": "Background--threeHrLine--3tNeU"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!./~/postcss-loader!./src/components/trends/common/Background.css
 ** module id = 102
 ** module chunks = 0
 **/